import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { SafePipe } from '../../../../shared/pipes';

interface DocumentData {
  url: string;
  filename: string;
  documentType?: {
    label: string;
  };
  createdAt?: string;
}

@Component({
  selector: 'app-document-viewer-modal',
  standalone: true,
  imports: [CommonModule, SafePipe],
  templateUrl: './document-viewer-modal.component.html',
  styleUrls: ['./document-viewer-modal.component.scss'],
})
export class DocumentViewerModalComponent implements OnInit {
  document: DocumentData | null = null;
  documentUrl: string | null = null;
  loading = true;
  error: string | null = null;
  isPdf = false;
  isImage = false;

  constructor() {}

  ngOnInit() {
    const data = ModalDataService.getData();
    if (data && data.document) {
      this.document = data.document;
      this.documentUrl = data.documentUrl;
      this.loading = false;
      this.determineFileType();
    } else {
      this.error = 'Aucun document fourni';
      this.loading = false;
    }
  }

  private determineFileType() {
    if (!this.documentUrl) return;

    const url = this.documentUrl.toLowerCase();

    console.log({ documentUrl: url });

    // PDF files
    if (url?.split('?')[0]?.endsWith('.pdf')) {
      this.isPdf = true;
    }

    // Image files
    else if (
      url.split('?')[0]?.endsWith('.jpg') ||
      url.split('?')[0]?.endsWith('.jpeg') ||
      url.split('?')[0]?.endsWith('.png') ||
      url.split('?')[0]?.endsWith('.gif') ||
      url.split('?')[0]?.endsWith('.bmp') ||
      url.split('?')[0]?.endsWith('.webp')
    ) {
      this.isImage = true;
    }
  }

  onImageError() {
    this.error = "Impossible de charger l'image";
  }
}
